import { supabase, isSupabaseConfigured } from '@/lib/supabase'

export type SaveQuickWriteInput = {
  childId: string
  promptId: string
  content: string
}

export type SaveQuickWriteResult = {
  quickWriteId: string
  ideaBankItemId: string
}

function countWords(text: string): number {
  const trimmed = text.trim()
  if (!trimmed) return 0
  return trimmed.split(/\s+/).length
}

export async function saveQuickWrite(
  input: SaveQuickWriteInput
): Promise<SaveQuickWriteResult | null> {
  if (!isSupabaseConfigured()) return null

  const trimmed = input.content.trim()
  if (!trimmed) {
    throw new Error('Cannot save empty quick write')
  }

  const wordCount = countWords(trimmed)

  const quickWriteResult = await supabase
    .from('quick_writes')
    .insert({
      child_id: input.childId,
      prompt_id: input.promptId,
      content: trimmed,
      word_count: wordCount,
    })
    .select()
    .single()

  if (quickWriteResult.error) {
    console.error('Failed to insert quick_writes:', quickWriteResult.error)
    throw quickWriteResult.error
  }

  const quickWriteId = (quickWriteResult.data as { id: string }).id

  const ideaBankResult = await supabase
    .from('idea_bank_items')
    .insert({
      child_id: input.childId,
      source: 'quick_write',
      source_quick_write_id: quickWriteId,
      content: trimmed,
      word_count: wordCount,
    })
    .select()
    .single()

  if (ideaBankResult.error) {
    console.error('Failed to insert idea_bank_items:', ideaBankResult.error)
    throw ideaBankResult.error
  }

  return {
    quickWriteId,
    ideaBankItemId: (ideaBankResult.data as { id: string }).id,
  }
}
